// Global config for the combined storefront embed bundle.
//
// The whole bundle ships as ONE storefront.js loaded from a single <script> tag,
// e.g.  <script src=".../js/storefront.js?apiKey=..." data-base="..."></script>
// so `document.currentScript` (captured once here, at bundle eval time) is that
// one tag. Per-widget config no longer lives on the script tag — each widget
// reads it from its own target element (see widgets/*). Only the values that are
// genuinely global (apiKey, app base URL) come from here.

// ── Feature kill-switches ────────────────────────────────────────────────────
// GW-470 Quotes — reversible kill-switch. While false, the embed hides every
// quote surface (the cart "Get a quote" button, the My-Quotes widget, and any
// account-menu link to /my-quotes) and skips wiring/injecting them. The API and
// its data are untouched — flip this back to `true` (and rebuild storefront.js)
// to re-enable, no other change needed. Mirror flag in the SPA: src/config.ts.
export var QUOTES_ENABLED = false;

// Captured at module-eval time = the storefront.js <script> element.
var _script = document.currentScript;
var _appBaseUrl = '';

// The API's central-auth iframe key — already hardcoded + publicly served in the
// legacy parts-search.js / my-garage.js. Accepted by every /api endpoint the
// embeds call. Used only as a last-resort fallback.
export var IFRAME_API_KEY = 'parts-finder-iframe-key-2024';

/** The bundle's own <script> element (or null if it couldn't be captured). */
export function getScript() {
  return _script;
}

/**
 * App base URL (origin + path up to /js/), derived from THIS script's src, with
 * a `data-base` override. Memoised. Trailing slash guaranteed.
 */
export function getAppBaseUrl() {
  if (_appBaseUrl) return _appBaseUrl;
  try {
    if (_script && _script.dataset && _script.dataset.base) {
      _appBaseUrl = _script.dataset.base;
    } else if (_script && _script.src) {
      var url = new URL(_script.src);
      var path = url.pathname.replace(/\/js\/storefront\.js.*$/i, '/');
      _appBaseUrl = url.origin + path;
    }
  } catch (e) { /* ignore */ }
  if (_appBaseUrl && !_appBaseUrl.endsWith('/')) _appBaseUrl += '/';
  return _appBaseUrl || '';
}

/**
 * Resolve the Bearer key FRESH each call: data-api-key → ?apiKey= on src →
 * window globals published by a sibling → iframe-key fallback. (Resolving lazily
 * matters because parts-finder-embed.js may publish the global after this bundle
 * first runs.)
 */
/**
 * The storefront's own parts-finder page for a part: where a card goes when the
 * part has no storefront product page (e.g. a price-on-request part that isn't
 * published there). Built on the page's origin, not getAppBaseUrl(), because the
 * /parts-finder page lives on the storefront; the app host has no such page.
 */
export function inAppPartUrl(partId) {
  var origin = '';
  try { origin = window.top.location.origin; } catch (e) { origin = window.location.origin; }
  return origin + '/parts-finder?view=part&part=' + encodeURIComponent(partId);
}

export function getApiKey() {
  var k = '';
  try {
    if (_script && _script.dataset && (_script.dataset.apiKey || _script.dataset.apikey)) {
      k = _script.dataset.apiKey || _script.dataset.apikey;
    }
    if (!k && _script && _script.src) k = new URL(_script.src).searchParams.get('apiKey') || '';
    if (!k) k = window.__PARTS_FINDER_API_KEY__ || window.PARTS_FINDER_API_KEY || '';
  } catch (e) { /* ignore */ }
  return k || IFRAME_API_KEY;
}
